import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "FleteAlmacenamientoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "FleteAlmacenamientoPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexFleteAlmacenamiento(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'FleteAlmacenamiento', name: 'FleteAlmacenamiento', title: 'FleteAlmacenamiento' },
                { data: 'Titular', name: 'Titular', title: 'Titular' },
                { data: 'Persona', name: 'Persona', title: 'Persona' },
                { data: 'Esposa', name: 'Esposa', title: 'Esposa' },
                { data: 'Hijos', name: 'Hijos', title: 'Hijos' },
                { data: 'Factor', name: 'Factor', title: 'Factor' },
                { data: 'TipoVia', name: 'TipoVia', title: 'TipoVia' },
                {
                    data: 'action',
                    orderable: true,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            rols: [],
            fletealmacenamientos: [],
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            fletealmacenamiento: {},
            
        };
    },
    methods: {
           
        newFleteAlmacenamiento() {
            this.fletealmacenamiento = {};
            this.$refs['frm-fletealmacenamiento'].show();
            // console.log("hhhhola")
        },
        showFleteAlmacenamiento(id) {
            this.isLoading=true;
            this.ss.showFleteAlmacenamiento(id).then(
                (result) => {
                    let response = result.data;
                    this.fletealmacenamiento = response.data;
                    this.$refs['view-fletealmacenamiento'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editFleteAlmacenamiento() {
            this.$refs['frm-fletealmacenamiento'].show();
            this.$refs['view-fletealmacenamiento'].hide();
        },
        cancelFleteAlmacenamiento() {
            if (this.fletealmacenamiento.id) {
                this.$refs['view-fletealmacenamiento'].show();
            }
            this.$refs['frm-fletealmacenamiento'].hide();
        },
        saveFleteAlmacenamiento() {
            this.ss.storeFleteAlmacenamiento(this.fletealmacenamiento).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-fletealmacenamiento'].hide();
                    this.$refs['datatable-fletealmacenamiento'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteFleteAlmacenamiento() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyFleteAlmacenamiento(this.fletealmacenamiento)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-fletealmacenamiento'].hide();
                                this.$refs['datatable-fletealmacenamiento'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        cambiopassword() {
            this.$refs['view-fletealmacenamiento'].hide();
            this.$refs['view-password'].show();
        },
        cancelPassword() {
            this.$refs['view-password'].hide();
            this.$refs['view-fletealmacenamiento'].show();
        },
        changePassword() {
            this.password.FleteAlmacenamiento = this.fletealmacenamiento.id;
            this.ss.changePassword(this.password)
                .then( result => {
                    let response = result.data;
                    if ( response.success ) {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Correcto',
                                variant: 'success',
                                autoHideDelay: 5000
                            }
                        )
                        this.$refs['view-password'].hide();
                        this.$refs['view-fletealmacenamiento'].show();
                    } else {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Oops',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                    }
                })
                .catch( error => {
                    console.log( error );
                    this.$bvToast.toast(
                        'Error al guardar el registro',
                        {
                            title: 'Oops',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                    this.errorBag = error.data.errors;
                })
        },
        draw() {
            window.$('.btn-datatable-FleteAlmacenamiento').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showFleteAlmacenamiento(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } 
    }
};
